"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PageFilterItemStyle {
    constructor(size = 280) {
        this.size = size;
    }
    static fromJSON(jsonObject) {
        return new PageFilterItemStyle(jsonObject && jsonObject.size || undefined);
    }
    toJSON() {
        return {
            size: this.size
        };
    }
}
exports.PageFilterItemStyle = PageFilterItemStyle;
//# sourceMappingURL=page-filter-item-style.js.map